
import React, {useEffect, useState} from "react";
import Layout from "../Layout/Layout";
import PageContent from "../Layout/PageContent";
import EmlForm from "../EmlForm";
const Metadata = () => {
    
  return (
    <Layout><PageContent>
       <EmlForm />
        </PageContent></Layout>
  );
}

export default Metadata;
